import { UnleashClient } from '@unleash/proxy-client-vue'

let instance: UnleashClient

export const getUnleashClient = () => {
  if (instance) return instance

  const runtimeConfig = useRuntimeConfig()
  const featureToggleConfig = {
    url: runtimeConfig.public.UNLEASH_URL,
    clientKey: runtimeConfig.public.UNLEASH_CLIENT_KEY,
    refreshInterval: Number(runtimeConfig.public.UNLEASH_REFRESH_INTERVAL),
    appName: runtimeConfig.public.UNLEASH_APP_NAME,
    environment: import.meta.env.MODE,
  }
  instance = new UnleashClient(featureToggleConfig)
  return instance
}
